module.exports = __webpack_public_path__ + "febac3ca44159e51c2c83ee2fbd30bf8.svg";